export default "__VITE_ASSET__BuMTgMcL__"